
<template>
  <div
    class="absolute_center"
    style="width: 2620px; overflow-y: scroll"
    :class="{
      _boxBg_green_secondLevel: styleType == 'typeGreen',
      _boxBg_dark_secondLevel: styleType == 'typeDark',
      _boxBg_blue_secondLevel: styleType == 'typeBlue',
      _boxBg_strong_secondLevel: styleType == 'typeStrong',
    }"
  >
    <div class="selfClose_btn" style="top: 10px" @click="close"></div>
    <div class="_boxTitle">水路运输台账</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item class="secondLevel-label" label="完工日期：">
              <DatePicker
                :init-width="'420px'"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="railwayDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'0'"
                @dateChange="changeTime"
              ></DatePicker>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="货物进出厂：">
              <el-select class="secondLevel-select" v-model="params.inOut" style="width: 200px">
                <el-option v-for="item in inOrOutList" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="货物类别：">
              <el-select class="secondLevel-select" v-model="params.vehicleUseType">
                <el-option v-for="item in materialTypeList" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="secondLevel-label" label="货物名称：">
              <el-input class="secondLevel-input" v-model="params.materialName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item
              style="
                margin-top: -10px;
                margin-bottom: 0;
                vertical-align: middle;
              "
              label=" "
            >
              <a class="self_btn" @click="handleCurrentChange(1)">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
              <a class="self_btn" @click="waterWayExport()">导出</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px">
          <el-table
            :data="dataList"
            style="width: 100%"
            :header-cell-class-name="'thClass'"
            :header-row-class-name="'headTrClass'"
            :cell-class-name="'tdClass'"
            :row-class-name="'trClass'"
            class="secondLevel_table"
          >
            <el-table-column label="序号" width="100" align="center" type="index" />
            <el-table-column :show-overflow-tooltip="true" prop="berth" label="泊位" width="120" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="vesselName" label="船名" width="150" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="waterwayNo" width="200" label="船舶识别号" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inOutType" label="货物进出厂" width="150" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="vehicleUseTypeName" label="货物类别" width="140" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="materialType" label="货物种类" align="center" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="materialName" label="货物名称" width="140" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="transportWeight" label="运输量(吨)" align="center" width="200"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="onboardTime" label="靠泊时间" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="startTime" label="开工时间" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="completeTime" label="完工时间" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="offboardTime" label="离泊时间" align="center"></el-table-column>
            <el-table-column v-if="customerId == 89" :show-overflow-tooltip="true" prop="shipper" label="发货单位" align="center"></el-table-column>
            <el-table-column v-if="customerId == 89" :show-overflow-tooltip="true" prop="consignee" label="收货单位" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="page_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.pageNo"
            :page-size="params.pageSize"
            layout="total,prev, pager, next, jumper"
            :total="page_total"
          ></el-pagination>
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { dateFormat } from 'utils/tools'
import { DatePicker } from '@/modules/commonDatePicker'
export default {
  name: 'waterWayDetail',
  title: '详细信息',
  props: ['globalInstance'],
  components: { DatePicker },
  setup(props) {
    const globalInstance = props.globalInstance
    return { globalInstance }
  },
  data() {
    return {
      pageInfo: 'waterWayDetail.vue',
      computedName: '水路运输台账组件',
      railwayDate: [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())],
      styleType: '',
      params: {
        inOut: '',
        vehicleUseType: '',
        materialName: '',
        startTime: '',
        endTime: '',
        pageNo: 1,
        pageSize: 10,
        customerId: this.$store.state.customerId
      },
      materialTypeList: [
        { value: '', label: '全部' },
        { value: '1', label: '大宗物料产品' },
        { value: '2', label: '非大宗物料产品' }
      ],
      inOrOutList: [
        { value: '', label: '全部' },
        { value: '0', label: '货物进厂' },
        { value: '1', label: '货物出厂' }
      ],
      page_total: 0,
      dataList: [],
      info: [],
      customerId: this.$store.state.customerId
    }
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: 'getDialogCompontent2'
    }),
    ...mapState({
      railwayTime: 'waterWayTime'
    }),
    curStyleTypeVal() {
      return this.globalInstance.$store.state.styleType
    }
  },
  created() {
    this.styleType = this.globalInstance.$store.state.styleType
  },
  mounted() {
    if (this.railwayTime.length > 0) {
      this.railwayDate = this.railwayTime
    }
    this.getTrainList()
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
      },
      deep: true
    }
  },
  methods: {
    changeTime(time) {
      this.railwayDate = time
    },
    async getTrainList() {
      // this.globalInstance.cleanTransportIp
      this.params.startTime = this.railwayDate[0]
      this.params.endTime = this.railwayDate[1]
      let url = this.globalInstance.cleanTransportIp + '/transport/waterway/list'
      let params = {
        ...this.params,
        materialName: this.params.materialName ? this.params.materialName : null,
        inOut: this.params.inOut !== '' ? this.params.inOut : null,
        vehicleUseType: this.params.vehicleUseType !== '' ? this.params.vehicleUseType : null
      }
      let res = await this.globalInstance.$apiUtils.get3(url, params)
      // let res = await this.globalInstance.$apiUtils.get3(
      //   "https://screen.bmetech.com/bme-access-control/transport/waterway/list?customerId=89&startTime=2023-04-13%2011:32:28&endTime=2023-05-30%2011:32:28&pageNo=1&pageSize=50&inOut=1&vehicleUseType=0",
      //   {}
      // );
      if (res && res.list) {
        this.dataList = res.list
        this.dataList.forEach(item => {
          if (item.inOut) {
            item.inOutType = '货物出厂'
          } else {
            item.inOutType = '货物进厂'
          }
          if (item.vehicleUseType == 1) {
            item.vehicleUseTypeName = '大宗物料产品'
          } else if(item.vehicleUseType == 2){
            item.vehicleUseTypeName = '非大宗物料产品'
          }
        })
      }
      if (res) {
        this.page_total = res.total
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.getTrainList()
    },
    reset() {
      this.params.inOut = ''
      this.params.pageNo = 1
      this.params.materialName = ''
      this.params.endTime = ''
      this.params.vehicleUseType = ''
      this.params.materialName = ''
      this.railwayDate = [dateFormat('YYYY-mm-dd', new Date()) + ' 00:00:00', dateFormat('YYYY-mm-dd HH:MM:SS', new Date())]
      this.getTrainList()
    },
    waterWayExport() {
      let that = this
      this.$message.info('正在导出数据……')
      let ip = this.globalInstance.cleanTransportIp
      let str = `${ip}/transport/waterway/export?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.railwayDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.railwayDate[1]
      )}&customerId=${this.customerId}&materialName=${this.params.materialName}&inOut=${this.params.inOut}&vehicleUseType=${
        this.params.vehicleUseType
      }`
      let a = document.createElement('a')
      console.log(str, 'str')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    close() {
      let that = this._.appContext.app
      this.$popup.close(that)
    }
  }
}
</script>
<style lang="scss" scoped>
.table_box .tdClass > .cell {
  font-size: 16px !important;
}
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
  .basic-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .basic-item {
      width: 33.3%;
      height: 60px;
      line-height: 30px;
      color: white;
      margin-bottom: 30px;
      .item-label {
        color: #a2d8ff;
      }
    }
  }
  .picture-info {
    margin-top: 140px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .picture-inner {
      width: 50%;
      margin-bottom: 25px;
      p {
        color: #a2d8ff;
        font-size: 22px;
        line-height: 130px;
        text-align: center;
      }
      .picture {
        padding: 10px;
        width: 100%;
        height: 340px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        // background-image: url("../img/img_bg.png");
        position: relative;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          font-weight: bold;
          color: #d7d7d7;
          font-size: 24px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: '';
          position: absolute;
          top: 20px;
          right: 20px;
          width: 54px;
          height: 54px;
          // background-image: url("./../img/enlarge.png");
        }
      }
    }
    .label-photo {
      margin-left: 10px;
    }
  }
}
.page_box {
  margin-top: 10px;
  align-items: flex-start !important;
}
:deep(.page_box .number) ,
:deep(.page_box .el-pagination__total),
:deep(.page_box .el-pagination__jump){
  font-size: 25px;
}

</style>
